import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const AuthorCooperations = React.lazy(() => import('./index'));
const AuthorCooperationTable = React.lazy(() => import('./authorCooperationTable'));
const AuthorCooperation = React.lazy(() => import('./authorCooperation'));
const AuthorCooperationDetail = React.lazy(() => import('./authorCooperationDetail'));
const AddNewAuthorCooperation = React.lazy(() => import('./addNewAuthorCooperation'));
const EditAuthorCooperation = React.lazy(() => import('./editAuthorCooperation'));

export const useAuthorCooperationRoutes = () => {

    return (
        <Route path="authorCooperations" element={<Suspense fallback={<div>منتظر باشید...</div>}><AuthorCooperations /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><AuthorCooperationTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewAuthorCooperation/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><AuthorCooperation/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><AuthorCooperationDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditAuthorCooperation/></Suspense> } />
            </Route>
        </Route>
    )
}